/**
 * Русский язык
 */

import type { Translations } from './uz';

export const ru: Translations = {
  common: {
    save: 'Сохранить',
    cancel: 'Отмена',
    delete: 'Удалить',
    edit: 'Редактировать',
    add: 'Добавить',
    search: 'Поиск',
    loading: 'Загрузка...',
    empty: 'Данные не найдены',
    error: 'Ошибка',
    success: 'Успешно',
    confirmDelete: 'Вы уверены, что хотите удалить?',
    yes: 'Да',
    no: 'Нет',
    total: 'Всего',
    page: 'Страница',
    previous: 'Предыдущая',
    next: 'Следующая',
    name: 'Название',
    phone: 'Телефон',
    email: 'Email',
    status: 'Статус',
    actions: 'Действия',
    currency_uzs: 'сум',
    close: 'Закрыть',
  },

  nav: {
    dashboard: 'Главная',
    kassa: 'Касса',
    orderRequests: 'Заказы',
    specialOrders: 'Новые заказы',
    products: 'Товары',
    categories: 'Категории',
    suppliers: 'Поставщики',
    customers: 'Клиенты',
    debts: 'Долги',
    debtCategories: 'Категории долгов',
    stats: 'Статистика',
    roles: 'Роли и сотрудники',
    users: 'Пользователи',
    xodimlar: 'Сотрудники',
    stores: 'Магазины',
    marketplaceOrders: 'Маркетплейс',
    pickupPoints: 'Пункты выдачи',
    promoCodes: 'Промокоды',
    marketplaceBanners: 'Баннеры',
    pickupOperator: 'Мой пункт',
    courier: 'Доставка',
    courierTracking: 'Курьеры',
    settings: 'Настройки',
    logout: 'Выход',
  },

  auth: {
    login: 'Вход',
    username: 'Логин',
    password: 'Пароль',
    signIn: 'Войти',
    welcome: 'Добро пожаловать',
    loginSubtitle: 'Войдите в систему AvtoFix POS',
    invalidCredentials: 'Неверный логин или пароль',
    loggingIn: 'Вход...',
  },

  products: {
    title: 'Товары',
    new: 'Новый товар',
    searchPlaceholder: 'Поиск по названию, SKU или штрихкоду...',
    statusAll: 'Все',
    statusAvailable: 'В наличии',
    statusPending: 'Ожидается',
    statusFinished: 'Закончился',
    empty: 'Товары не найдены',
    emptyHint: 'Добавьте первый товар',
    deleted: 'Товар удалён',
  },

  customers: {
    title: 'Клиенты',
    new: 'Новый клиент',
    searchPlaceholder: 'Поиск по имени, телефону или email...',
    empty: 'Клиенты не найдены',
    orderCount: 'Заказы',
    totalSpent: 'Всего',
    vip: 'VIP',
    created: 'Клиент добавлен',
    updated: 'Клиент обновлён',
    deleted: 'Клиент удалён',
  },

  debts: {
    title: 'Долги',
    statusPending: 'Ожидает',
    statusPaid: 'Оплачен',
    statusOverdue: 'Просрочен',
    statusBlacklist: 'Чёрный список',
    amount: 'Долг',
    paid: 'Оплачено',
    remaining: 'Остаток',
    pay: 'Оплата',
    payAmountPrompt: 'Сумма оплаты (остаток: {{remaining}} сум):',
    invalidAmount: 'Неверная сумма',
    paidFully: 'Долг полностью оплачен',
    paidPartial: 'Принята частичная оплата',
    blacklistConfirm: 'Занести клиента в чёрный список?',
    blacklisted: 'Занесён в чёрный список',
    empty: 'Долги не найдены',
  },

  stats: {
    title: 'Статистика',
    subtitle: 'Доход, топ товары, долги — в реальном времени',
    periodToday: 'Сегодня',
    periodWeek: 'Последние 7 дней',
    periodMonth: 'Последние 30 дней',
    revenue: 'Доход',
    profit: 'Прибыль',
    orders: 'Заказы',
    customers: 'Клиенты',
    cash: 'Наличные',
    card: 'Карта',
    transfer: 'Перевод',
    topProducts: 'Топ продаваемых товаров',
    noSales: 'Нет продаж',
    debtsTitle: 'Долги',
    totalDebt: 'Всего долгов',
    outstanding: 'Остаток',
    lowStock: 'Мало на складе',
    lowStockHint: '{{count}} товаров ниже минимума',
  },

  users: {
    title: 'Сотрудники',
    new: 'Новый сотрудник',
    username: 'Логин',
    role: 'Роль',
    active: 'Активен',
    empty: 'Нет сотрудников',
    blocked: 'Заблокирован',
    activated: 'Активирован',
  },

  stores: {
    title: 'Магазины',
    new: 'Новый магазин',
    mainStore: 'Главный магазин',
    setAsMain: 'Сделать главным магазином',
    address: 'Адрес',
    empty: 'Нет магазинов',
    usdRate: 'Курс USD',
    markup: 'Наценка',
    brand: 'Бренд',
  },

  offline: {
    online: 'Онлайн',
    offline: 'Офлайн',
    syncing: 'Синхронизация...',
    pending: 'Ожидает: {{count}}',
    dlq: 'Ошибок: {{count}}',
  },
};
